/* eslint-disable max-len */
import React from 'react';
import { Dialog, Button } from '@leverege/ui-elements';
import { TitleBar } from '@leverege/ui-plugin';
import { GroupActions } from '@leverege/molten/imagine';
import { GlobalState } from '@leverege/ui-redux';
import { FilterSourceModel } from '@leverege/molten/filters';
import S from './PositionPending.css';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export default class PositionPendingDialog extends React.Component {
  getActions = actions => {
    return new GroupActions({
      ...actions,
      queryName: 'positionPendingCounter'
    });
  };
  learnMore = () => {
    window.open('https://help.recovr.biz/en/articles/5937398-vehicle-position-pending', '_blank');
  };
  onSearchChange = () => {
    const model = {
      type: 'equals',
      value: true
    };
    const {
      context: {
        clientProps: {
          filter,
          objectType,
          onFilterChange
        }
      }
    } = this.props;
    let filterMetadata;

    // Based on the object type we're dealing with, populate the search field and the filter metadata
    // so that the corresponding filters on the filter table itself will be selected
    if (objectType === 'assetLocators') {
      model.field = 'data/locator/data/pairedPositionPending';
      filterMetadata = {
        type: 'table.FilterModel',
        filters: {
          'assetLocators.calculatedAlerts': {
            type: 'filter.calculatedAlerts',
            field: {},
            value: ['positionPending'],
            empty: false
          }
        },
        sorts: []
      };
    } else {
      model.field = 'data/pairedPositionPending';
      filterMetadata = {
        type: 'table.FilterModel',
        filters: {
          'locator.pairedPositionPending': {
            type: 'filter.equals',
            field: 'data/pairedPositionPending',
            fieldType: 'boolean',
            value: [true],
            empty: false
          }
        },
        sorts: []
      };
    }
    let newFilter = FilterSourceModel.setFilter(filter, model);
    newFilter = FilterSourceModel.setMetadata(newFilter, filterMetadata);
    if (newFilter !== filter && newFilter != null) {
      onFilterChange({
        data: 'table',
        value: newFilter,
        isOnMount: true
      });
    }
  };
  onLinkClick = () => {
    const {
      onClose
    } = this.props;
    this.onSearchChange();
    onClose();
  };
  render() {
    const {
      show,
      onClose,
      context
    } = this.props;
    const list = this.getActions(context.clientProps.actions).getList(GlobalState.get());
    const numPending = list.aggs.positionPendingAgg.count;
    const equipmentWord = numPending === 1 ? 'equipment' : 'equipments';
    const hasWord = numPending === 1 ? 'has' : 'have';
    const locatorsWord = numPending === 1 ? 'a locator' : 'locators';
    const linkText = `${numPending} ${equipmentWord}`;
    const message = ` ${hasWord} been recently paired to ${locatorsWord}. Position updates after the initial pairing can take up to 1 hour. Sit tight while we get those positions loaded on the map for you.`;
    return /*#__PURE__*/_jsxs(Dialog.Question, {
      show: show,
      title: /*#__PURE__*/_jsx(TitleBar, {
        variant: "dialogTitleNoPad",
        icon: "https://recovr-ui-assets.storage.googleapis.com/position-pending-dialog-icon.png",
        title: "Position Pending"
      }),
      okay: "Close",
      cancel: "Learn More",
      onOkay: onClose,
      onClose: onClose,
      onCancel: this.learnMore,
      children: [/*#__PURE__*/_jsxs(Button, {
        variant: "linkNoPad",
        className: S.filterLink,
        onClick: this.onLinkClick,
        children: [" ", linkText]
      }), message]
    });
  }
}